import { module } from 'modujs';
import gsap from 'gsap';
import { getCoords } from '../utils/utilities';
import Channels from '../base/channels';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };

    this.VARS = {
      scale: this.DOM.view.dataset.value.split(','),
      steps: [],
      stepsPosX: [],
      startPosX: 0,
    };
    this.calculate();
    this.fnResize = this.resize.bind(this);
    Channels.addListener('window::smartresize', this.fnResize);
  }

  calculate() {
    for (let trigger of this.$('trigger')) {
      const posX = trigger.offsetLeft;
      const temperature = parseInt(trigger.innerHTML);
      this.VARS.steps.push(temperature);
      if (temperature == this.VARS.scale[0]) {
        this.VARS.startPosX = posX;
      }
    }
    this.VARS.range = Math.abs(
      this.VARS.steps[0] - this.VARS.steps[this.VARS.steps.length - 1]
    );
    this.VARS.captureRange = Math.abs(this.VARS.scale[0] - this.VARS.scale[1]);
    this.VARS.scaleRange = this.VARS.captureRange / this.VARS.range;
    this.VARS.newWidth =
      getCoords(this.$('receptor')[0]).width * this.VARS.scaleRange;
  }

  reset() {
    this.VARS.steps = [];
    this.VARS.stepsPosX = [];
    this.VARS.startPosX = 0;
    gsap.set(this.$('receptor'), { clearProps: 'width' });
  }

  resize() {
    this.reset();
    this.calculate();
    this.start();
  }

  start() {
    gsap.fromTo(
      this.$('receptor'),
      { width: 0, left: this.VARS.startPosX + 5 },
      { width: this.VARS.newWidth, duration: 0.8, ease: 'quint.inOut' }
    );
  }

  destroy() {
    Channels.removeListener('window::smartresize', this.fnResize);
  }
}
